<!-- Classes main-div and example-card are catagorized in .css file -->
<div class="login-header">
  <!-- <div class="language-item row">
    <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('vi')"
      [matTooltip]="'header.vietnamese' | translate"><img class="vt-cursor-pointer" src="./assets/images/vietnam.png"
        alt="vietnamese"></a>
    <a class="nav-link vt-cursor-pointer" (click)="onChangeLanguage('en')"
      [matTooltip]="'header.english' | translate"><img class="vt-cursor-pointer"
        src="./assets/images/united-kingdom.png" alt="english"></a>
  </div> -->
</div>
<div class="login-wrapper d-flex flex-column pl-2 pr-4">
 <ng-container *ngIf="mode === 'LOGIN'">
<!--  <div>-->
<!--    <div class="col-md-12 pr-0 notify-card mb-2">-->
<!--      <div class="card boxshadow-card" style="border-radius: 15px;">-->
<!--        <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">-->
<!--          <div class="d-flex">-->
<!--            <div>-->
<!--              <i (click)="loginWithCapCha()" class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>-->
<!--            </div>-->
<!--            <div class="flex-grow-3 pl-2">-->
<!--              <span>{{'cancel_sign_confirm.system_notify_message_key' | translate}}</span>-->
<!--            </div>-->
<!--            <div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
   <mat-card *ngIf="!isSignAnonymousWithCapCha" class="login-card">

     <form #f="ngForm" (ngSubmit)="isFormValid() && login()" appFocusFirstElement>
       <!--logo-->
       <mat-card-header>
         <div mat-card-avatar class="text-center">
           <img alt="Logo" src="../../../../assets/images/logo_vcontract.png" width="46%">
         </div>
       </mat-card-header>

       <!--chọn ngôn ngữ-->
       <div class="text-center txt-select-languages">
         <!-- <a (click)="onChangeLanguage('vi')">{{'header.vietnamese' | translate}}</a>
         <a class="english_border_right" (click)="onChangeLanguage('en')">{{'header.english' | translate}}</a>
         <br> -->
        <button type="button" class="d-flex select-language" [matMenuTriggerFor]="menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
          <div>
            <img *ngIf="currentLanguage == 'vi'" class="vt-cursor-pointer" src="../../../../assets/images/vn.svg" alt="vietnamese" width="30" height="20">
            <img *ngIf="currentLanguage == 'en'" class="vt-cursor-pointer" src="../../../../assets/images/en.svg" alt="english" width="30" height="20">
            <img *ngIf="currentLanguage == 'zh'" class="vt-cursor-pointer" src="../../../../assets/images/china.svg" alt="china" width="30" height="20">
            <img *ngIf="currentLanguage == 'es'" class="vt-cursor-pointer" src="../../../../assets/images/es.svg" alt="china" width="30" height="20">
          </div>
          <span class="">{{getCurrentNameLanguage()}}</span>
          <div class="">
              <em *ngIf="isOpen" class="material-icons">keyboard_arrow_up</em>
              <em *ngIf="!isOpen" class="material-icons">keyboard_arrow_down</em>
          </div>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onChangeLanguage('vi')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'vi'}">
              <img class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
              {{'Tiếng Việt' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('en')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'en'}">
              <img class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
              {{'English' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('zh')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'zh'}">
              <img class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
              {{'中国人' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('es')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'zh'}">
              <img class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
              {{'Español' | translate}}
          </button>
        </mat-menu>
       </div>

       <!--text đăng nhập-->
       <div class="vt-text-login-header text-center">{{'login_page.btn_login' | translate}}</div>
       <span class="mb-3">{{'login_page.guiding_login_without_username' | translate}}</span>
       <!--form đăng nhập-->
       <mat-card-content class="pt-2 mt-2">
         <mat-form-field class="w-100">
           <mat-label class="cls-txt-mat-label">{{'login_page.lbl_email_phone' | translate}}</mat-label>
           <input appAutoFocus matInput type="text" placeholder="{{'login_page.lbl_email_phone' | translate}}"
                  name="usname" #usname="ngModel" [(ngModel)]="username"
                  [pattern]="emailPattern" maxlength="200" required
                  id="username" (focusout)="username = username.trim()">
           <mat-error *ngIf="usname?.errors?.required">
             <span class="text-error">{{'validation.email_phone_required' | translate}}</span>
           </mat-error>
           <mat-error *ngIf="usname?.errors?.pattern">
             <span class="text-error">{{'validation.email_format' | translate}}</span>
           </mat-error>
         </mat-form-field>

         <mat-form-field class="w-100">
           <mat-label class="cls-txt-mat-label">{{'login_page.lbl_password' | translate}}</mat-label>
           <input [type]="passwordVisibility ? 'text' : 'password'" matInput
                  placeholder="{{'login_page.lbl_password' | translate}}" name="pass"
                  #pass="ngModel" [(ngModel)]="password" ngModel maxlength="100" id="idPassword" required>
           <mat-error *ngIf="pass?.errors?.required">
             <span class="text-error">{{'validation.pass_required' | translate}}</span>
           </mat-error>
           <button matSuffix mat-icon-button color="primary" type="button"
                   (click)="passwordVisibility = !passwordVisibility">
             <mat-icon>{{!passwordVisibility ? 'visibility_off' : 'visibility'}}</mat-icon>
           </button>
           <mat-error *ngIf="!validUsernameFormat || !validPasswordFormat">
             <span class="text-error">{{'messages.wrong_credential' | translate}}</span>
           </mat-error>
         </mat-form-field>

         <re-captcha *ngIf="failedLoginCount && failedLoginCount >= limitFailedLoginNoReCaptcha" name="captcha"
                     #reCaptcha="ngModel" [(ngModel)]="captcha" required></re-captcha>
         <mat-error *ngIf="showReCaptchaRequiredErr">
           <span class="text-error">{{'validation.captcha_required' | translate}}</span>
         </mat-error>
       </mat-card-content>

       <!--submit-->
       <mat-card-actions class="mb-0" style="margin: unset;">
         <button mat-raised-button color="primary" type="submit"
                 class="w-100">{{'login_page.btn_login' | translate}}</button>
       </mat-card-actions>
     </form>
   </mat-card>
   <mat-card *ngIf="isSignAnonymousWithCapCha" class="login-card">
     <form #f="ngForm" (ngSubmit)="isFormValid() && loginWithCapCha()" class="text-center" appFocusFirstElement>
       <!--logo-->
       <mat-card-header>
         <div mat-card-avatar class="text-center">
           <img alt="Logo" src="../../../../assets/images/logo_vcontract.png" width="46%">
         </div>
       </mat-card-header>

       <!--chọn ngôn ngữ-->
       <div class="text-center txt-select-languages mt-3">
         <!-- <a (click)="onChangeLanguage('vi')">{{'header.vietnamese' | translate}}</a>
         <a class="english_border_right" (click)="onChangeLanguage('en')">{{'header.english' | translate}}</a>
         <br> -->
        <button type="button" class="select-language" [matMenuTriggerFor]="menu" (menuOpened)="isOpen = true" (menuClosed)="isOpen = false">
          <div>
            <img *ngIf="currentLanguage == 'vi'" class="vt-cursor-pointer" src="../../../../assets/images/vn.svg" alt="vietnamese" width="30" height="20">
            <img *ngIf="currentLanguage == 'en'" class="vt-cursor-pointer" src="../../../../assets/images/en.svg" alt="english" width="30" height="20">
            <img *ngIf="currentLanguage == 'zh'" class="vt-cursor-pointer" src="../../../../assets/images/china.svg" alt="china" width="30" height="20">
            <img *ngIf="currentLanguage == 'es'" class="vt-cursor-pointer" src="../../../../assets/images/es.svg" alt="spanish" width="30" height="20">
          </div>
          <span class="">{{getCurrentNameLanguage()}}</span>
          <div class="">
              <em *ngIf="isOpen" class="material-icons">keyboard_arrow_up</em>
              <em *ngIf="!isOpen" class="material-icons">keyboard_arrow_down</em>
          </div>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onChangeLanguage('vi')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'vi'}">
              <img class="vt-cursor-pointer" src="./assets/images/vn.svg" alt="vietnamese" width="30" height="20">
              {{'Tiếng Việt' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('en')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'en'}">
              <img class="vt-cursor-pointer" src="./assets/images/en.svg" alt="english" width="30" height="20">
              {{'English' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('zh')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'zh'}">
              <img class="vt-cursor-pointer" src="./assets/images/china.svg" alt="china" width="30" height="20">
              {{'中国人' | translate}}
          </button>
          <button mat-menu-item (click)="onChangeLanguage('es')" style="width: 140px;"
              [ngClass]="{'active-btn': currentLanguage == 'es'}">
              <img class="vt-cursor-pointer" src="./assets/images/es.svg" alt="spanish" width="30" height="20">
              {{'Español' | translate}}
          </button>
        </mat-menu>
       </div>

       <!--text đăng nhập-->
       <div class="vt-text-login-header text-center">{{'login_page.sign_anounymous' | translate}}</div>
 <!--      <button (click)="skipCaptcha()">Login</button>-->
       <span class="mb-3">{{'login_page.guiding_login_with_captcha' | translate}}</span>
       <!--form đăng nhập-->
       <mat-card-content class="ml-4 pt-2 mt-2">
         <!-- <re-captcha name="captcha"
                     #reCaptcha="ngModel" [(ngModel)]="captcha"  (resolved)="resolvedCaptCha($event)" required></re-captcha>
         <mat-error *ngIf="showReCaptchaRequiredErr">
           <span class="text-error">{{'validation.captcha_required' | translate}}</span>
         </mat-error> -->

         <app-slide-captcha
          (verifyHandle)="resolvedCaptCha($event)"
          >

          </app-slide-captcha>
       </mat-card-content>
     </form>
   </mat-card>
 </ng-container>
 <ng-container *ngIf="mode === 'SEARCH_CLOUD_CA'">
    <app-anonymous-cloud-ca
      (actionBack)="onChangeAction($event)"
    ></app-anonymous-cloud-ca>
 </ng-container>
 <ng-container *ngIf="mode === 'SIGN'">
    <app-anonymous-two-factor-authen
      (confirmSendRequest)="afterVerifyTwoAuthen($event)"
      (changeMode)="changeMode($event)"
      [isAnonymousLogin]="true"
    ></app-anonymous-two-factor-authen>
 </ng-container>
</div>

<div class="login-footer">
  <div class="container-fluid py-3">
    <div class="row">
      <div class="col-12">
        <h5 class="text-white">{{'footer.contact' | translate}}</h5>
      </div>
    </div>
    <div class="footer-info">
      <div>
        {{'footer.hot_line' | translate}} {{phoneNumber}}<br>{{'footer.email_detail' | translate}}
      </div>
      <div class="footer-info-left">
        {{'footer.copy-right' | translate}}<br>{{'footer.powered' | translate}}
      </div>
    </div>
  </div>
</div>
